<!-- Navbar -->
    <!-- Container -->
    <div class="kt-container-fluid flex flex-wrap justify-between items-center gap-2">
        <div class="grid">
            <div class="kt-scrollable-x-auto">
                <div class="kt-menu gap-5 lg:gap-7.5" data-kt-menu="true">
                    <div class="kt-menu-item py-3.5 border-b border-transparent kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono">
                        <a class="kt-menu-link gap-2.5" href="#">
                            <span class="kt-menu-title text-nowrap font-medium text-sm text-secondary-foreground kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-link-hover:text-mono">
                                Dashboards
                            </span>
                        </a>
                    </div>
                    <div class="kt-menu-item py-3.5 border-b border-transparent kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono">
                        <a class="kt-menu-link gap-2.5" href="#">
                            <span class="kt-menu-title text-nowrap font-medium text-sm text-secondary-foreground kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-link-hover:text-mono">
                                Public Profiles
                            </span>
                        </a>
                    </div>
                    <div class="kt-menu-item py-3.5 border-b border-transparent kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono">
                        <a class="kt-menu-link gap-2.5" href="#">
                            <span class="kt-menu-title text-nowrap font-medium text-sm text-secondary-foreground kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-link-hover:text-mono">
                                Account Settings
                            </span>
                        </a>
                    </div>
                    <div class="kt-menu-item py-3.5 border-b border-transparent kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono">
                        <a class="kt-menu-link gap-2.5" href="#">
                            <span class="kt-menu-title text-nowrap font-medium text-sm text-secondary-foreground kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-link-hover:text-mono">
                                Network
                            </span>
                        </a>
                    </div>
                    <div class="kt-menu-item py-3.5 border-b border-transparent kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono">
                        <a class="kt-menu-link gap-2.5" href="#">
                            <span class="kt-menu-title text-nowrap font-medium text-sm text-secondary-foreground kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-link-hover:text-mono">
                                Authentication
                            </span>
                        </a>
                    </div>
                    <div class="kt-menu-item py-3.5 border-b border-transparent kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono">
                        <a class="kt-menu-link gap-2.5" href="#">
                            <span class="kt-menu-title text-nowrap font-medium text-sm text-secondary-foreground kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-link-hover:text-mono">
                                Store - Client
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Container -->
<!-- End of Navbar -->